export function isDocFlowTableRowConnectedRequestsDetailCurrent({
  detail,
  items,
}) {
  return detail?.sourceItems === items
}

export function isDocFlowTableRowConnectedRequestsListPartial({
  count,
  items,
}) {
  return count > items.length
}

export function getDocFlowTableRowConnectedRequestsCellItems({
  detail,
  items,
}) {
  return (
    (isDocFlowTableRowConnectedRequestsDetailCurrent({ detail, items }) &&
      detail.items) ||
    items
  )
}
